import { styled } from 'styled-components';
import { Button } from 'antd';

export const RegistrationContentBody = styled.div`
  display: flex;
  height: 706px;
  @media (max-width: 820px),
    (max-device-width: 1280px) and (orientation: portrait) {
    flex-direction: column;
    height: calc(80vh - 30px);
  }

  @media (max-width: 1280px) and (orientation: landscape) {
    height: calc(80vh - 30px);
  }
`;

export const LeftRegistrationContentWrapper = styled.div`
  width: 45%;
  padding-right: 8px;

  @media (max-width: 820px),
    (max-device-width: 1280px) and (orientation: portrait) {
    display: none;
  }

  @media (max-device-width: 1280px) and (orientation: landscape) {
    display: none;
  }
`;

export const RightRegistrationContentWrapper = styled.div`
  width: 55%;
  padding-right: 16px;
  display: flex;
  flex-direction: column;
  overflow: auto;
  position: relative;

  p {
    margin: 8px;
  }

  @media (max-width: 820px),
    (max-device-width: 1280px) and (orientation: portrait) {
    width: 100%;
    padding-right: 0;
  }

  @media (max-device-width: 1280px) and (orientation: landscape) {
    width: 100%;
    padding-right: 0;
  }
`;

export const RegistrationContentFooter = styled.div`
  display: flex;
  justify-content: space-between;
  position: sticky;
  bottom: 0;
  background: white;
  padding: 16px 0 0;
  margin-top: auto;
  z-index: 10;

  button {
    height: 40px;
    padding: 8px;
    span {
      font-family: Lato, sans-serif;
    }
  }

  @media (max-width: 480px),
    (max-device-width: 1280px) and (orientation: portrait) {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    margin: 0;
    padding: 16px;
    flex-direction: column;
    gap: 24px;
    background: white;
  }
`;

export const BackButton = styled.div<{ theme: any }>`
  height: 40px;
  width: 40px;
  cursor: pointer;
  border: 1px solid #dedede;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;

  img {
    transform: translateY(-2px);
  }

  &:hover {
    border-color: black;
    transition: all 0.2s ease-in-out;
  }
  .back-text {
    display: none;
  }

  @media (max-width: 480px),
    (max-device-width: 1280px) and (orientation: portrait) {
    margin-top: 24px;
    width: 100%;
    height: auto;
    min-height: 40px;
    .back-text {
      display: inline;
      color: black;
      font-family: Lato;
      font-weight: 600;
      margin-left: 8px;
    }
  }
`;

export const NextStepButton = styled(Button)`
  &&.ant-btn.ant-btn-primary {
    margin-left: auto;

    @media (max-width: 480px),
      (max-device-width: 1280px) and (orientation: portrait) {
      box-shadow: none;
      padding: 0px 8px;
      width: 100%;
      height: auto;
      min-height: 40px;
    }
  }
`;

export const InfoWrapper = styled.div`
  border: 1px solid #dedede;
  border-radius: 8px;
  padding: 8px 16px;
  margin-bottom: 20px;
  margin-top: 20px;
  @media (max-width: 820px),
    (max-device-width: 1280px) and (orientation: portrait) {
    margin-bottom: 16px;
    margin-top: 8px;
  }
`;

export const AgeTextWrapper = styled.div`
  border: 1px solid #dedede;
  background: #f5f5f5;
  border-radius: 4px;
  padding: 2px 8px;
`;
